export const configData = {
  data() {
    return {
      FIXED: 'duration_fixed',
      PICKER: 'duration_picker',
      FIXED_ENTRY: 'fixed_entry',
      LANGUAGES: {
        'en': 'English',
        'et': 'Estonian',
        'ru': 'Russian'
      },
      DEF_LANG: 'et'
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/tenants/ticket-types/mixins/configData.js